<div class="tag {{ customClass }}" [class.disabled]="isDisabled">
    <i *ngIf="tagIcon" class="{{ tagIcon }}"></i>
    <span>{{ label }}</span>
    <i *ngIf="isRemovable" class="icon-close-default-16" (click)="$event.stopPropagation();removed.emit()"></i>
    <label *ngIf="showTagCount">{{ count }}</label>
</div>
